<script>
    import DatePicker from '@/components/Shared/DatePicker';

    export default {
        extends: DatePicker,

        props: {
            isReconnectOrganization: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            isDateDisabled(date) {
                if (this.isDateDisabledByMinOrMax(date)) {
                    return true;
                }

                if (this.isReconnectOrganization) {
                    return this.isDateDisabledByReconnectOrganization(date);
                }

                return false;
            },

            isDateDisabledByReconnectOrganization(date) {
                // Possible start date is: "last tuesday of every month except not withing 2 days"
                const isLastTuesday = utils.isLastTuesday(date);

                const now = new Date();
                const timeDiff = Math.abs(now.getTime() - date.getTime());
                const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                return ! isLastTuesday || diffDays <= 2;
            },
        },
    };
</script>